import React from 'react';

const AboutMe = () => {
    return (
        <section id="about-me" className="about-me-section bg-dark-blue px-6 py-10" style={{ minHeight: '30vh' }}>
    <h2 className="font-bold text-2xl mb-2">About Me</h2>
    <p className="max-w-3xl mx-auto">
      Software Engineer with a Master's in Computer Science from NTNU, specializing in
      full-stack development and NLP research. I've built and optimized high-throughput
      APIs at Whitson LLC, developed real-time traffic systems at Bouvet/Statens vegvesen,
      and shipped full-stack web apps at Wiseline AS. My Master's thesis applied transformer
      models to analyze extremist rhetoric across 1.2M+ social media records.
      Beyond tech, I love travel, fitness, and exploring new cultures.
    </p>
</section>
    );
};

export default AboutMe;
